// extracted by mini-css-extract-plugin
module.exports = {"telemetryView":"TwoMainDevice_telemetryView__1SUAn","mainLeftTelemetry":"TwoMainDevice_mainLeftTelemetry__bP24m","mainRightTelemetry":"TwoMainDevice_mainRightTelemetry__2w5pA"};